export default "__VITE_ASSET__JiJnVh2k__"